import { Video } from "./video";

export interface TrainingSessionTpl {
    id: number;
    name: string;
    description: string;
    goals: string;
    phases: TrainingSessionPhaseTpl[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyTrainingSessionTpl: TrainingSessionTpl = {
    id: 0,
    name: '',
    description: '',
    goals: '',
    phases: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface TrainingSessionTplRecipient {
    type: string;
    reference: string;
    label: string;
}

export interface TrainingSessionPhaseTpl {
    id: number;
    name: string;
    description: string;
    goals: string;
    videos: Video[],
    weight: number;
    recipients: TrainingSessionTplRecipient[];
    exercises: TrainingSessionExerciseTpl[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyTrainingSessionPhaseTpl: TrainingSessionPhaseTpl = {
    id: 0,
    name: '',
    description: '',
    goals: '',
    videos: [],
    weight: 0,
    recipients: [],
    exercises: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface TrainingSessionExerciseTpl {
    id: number;
    name: string;
    description: string;
    goals: string;
    videos: Video[],
    weight: number;
    recipients: TrainingSessionTplRecipient[],
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyTrainingSessionExerciseTpl: TrainingSessionExerciseTpl = {
    id: 0,
    name: '',
    description: '',
    goals: '',
    videos: [],
    weight: 0,
    recipients: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}